import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { FavoriteHeart } from 'pages/avia/favorites/components/favorites-heart'
import { useFavorites } from 'pages/avia/favorites/hooks'
import { FavoritesRequestBody } from 'pages/avia/favorites/hooks/types.ts'

import { setSettingForApp } from 'entities/user/module/app-settings'

import { ShareKeys } from 'shared/constants'
import { TicketItem } from 'shared/models/ticket.ts'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import styles from './styles.module.scss'

interface Props {
  ticket?: TicketItem
  totalCountPassengers: number
  favoritesParams: FavoritesRequestBody
  onBack: () => void
}

export const Header = observer(({ onBack, ticket, favoritesParams }: Props) => {
  const { t } = useTranslation()

  const { onAddFavorite, onRemoveFavorite } = useFavorites({
    favoritesSearchKey: ticket?.favorite_search_key,
    favoritesParams,
    onError: () => {
      void setSettingForApp({
        key: ShareKeys.avia,
        value: JSON.stringify(ticket),
      })
    },
    onSuccess: () => {
      void setSettingForApp({ key: ShareKeys.avia, value: '' })
    },
  })

  return (
    <HeaderGoBack
      onGoBack={onBack}
      title={t('purchase_page.detail_fly')}
      actionRight={
        ticket?.favorite_search_key && (
          <FavoriteHeart
            onAdd={onAddFavorite}
            onRemove={onRemoveFavorite}
            key={String(ticket?.is_favorite)}
            defaultActive={ticket?.is_favorite}
          />
        )
      }
      buttonWhite
    >
      <div className={styles.title}>
        <span className="bold-17">{t('purchase_page.detail_fly')}</span>
      </div>
    </HeaderGoBack>
  )
})
